<app-expansion-panel [isExpanded]="true">
    <span
        class="font-medium text-xl"
        header>
        {{ 'attribute' | transloco }}</span
    >

    <div
        class="flex-1 min-h-0"
        content>
        @if (!bookmarkedAttributes().length && !notBookmarkedAttributes().length) {
            <p class="!m-0 text-sm text-custom-text-grey">{{ 'entityAttributesNotFilled' | transloco }}</p>
        }

        @if (bookmarkedAttributes().length) {
            <span class="font-medium">
                <fa-icon
                    class="mr-1 title-icon text-custom-blue font-medium text-xl"
                    [icon]="['fas', 'star']" />
                {{ 'favoriteAttributes' | transloco }}
            </span>
            <div class="mb-3 grid grid-cols-2 gap-4">
                @for (bookmarkedAttribute of formattedBookmarkedAttributes(); track bookmarkedAttribute.key) {
                    @if (
                        editEntityDetailService.isEditMode() &&
                        editEntityDetailService.bookmarkedAttributesForm() &&
                        editEntityDetailService.informationSchemaTableList().length
                    ) {
                        <app-entity-attributes-input
                            [attribute]="bookmarkedAttribute"
                            [attributesForm]="editEntityDetailService.bookmarkedAttributesForm()!"
                            [columnNamesWithReference]="columnNamesWithReference()"
                            [disabled]="
                                editEntityDetailService.businessIdentifierKey() === bookmarkedAttribute.key ||
                                !isLayerEditable() ||
                                nonEditableColumnsName().includes(bookmarkedAttribute.key)
                            "
                            [informationSchemaTable]="
                                editEntityDetailService.findCurrentInformationSchemaTable(bookmarkedAttribute.key)
                            "
                            [label]="bookmarkedAttribute.label"
                            [labelTooltip]="bookmarkedAttribute.labelTooltip"
                            [tooltip]="
                                editEntityDetailService.businessIdentifierKey() === bookmarkedAttribute.key
                                    ? ('modifyBusinessIdentifier' | transloco)
                                    : (nonEditableColumnsReasonByName()[bookmarkedAttribute.key] ?? undefined)
                            " />
                    } @else {
                        <div class="py-1">
                            <div
                                class="text-sm text-custom-text-grey"
                                [matTooltip]="bookmarkedAttribute.labelTooltip"
                                [matTooltipDisabled]="!bookmarkedAttribute.labelTooltip">
                                {{ bookmarkedAttribute.label }}
                            </div>
                            <div class="text-sm font-medium">{{ bookmarkedAttribute.formattedValue }}</div>
                        </div>
                    }
                }
            </div>
        }

        @if (showAll()) {
            @if (bookmarkedAttributes().length) {
                <mat-divider />
            }

            <div class="mt-3 mb-3 grid grid-cols-2 gap-4">
                @for (notBookmarkedAttribute of formattedNotBookmarkedAttributes(); track notBookmarkedAttribute.key) {
                    @if (!readOnlyAttributes.includes(notBookmarkedAttribute.key)) {
                        @if (
                            editEntityDetailService.isEditMode() &&
                            editEntityDetailService.notBookmarkedAttributesForm()
                        ) {
                            <app-entity-attributes-input
                                [attribute]="notBookmarkedAttribute"
                                [attributesForm]="editEntityDetailService.notBookmarkedAttributesForm()!"
                                [columnNamesWithReference]="columnNamesWithReference()"
                                [disabled]="
                                    editEntityDetailService.businessIdentifierKey() === notBookmarkedAttribute.key ||
                                    !isLayerEditable() ||
                                    nonEditableColumnsName().includes(notBookmarkedAttribute.key)
                                "
                                [informationSchemaTable]="
                                    editEntityDetailService.findCurrentInformationSchemaTable(
                                        notBookmarkedAttribute.key
                                    )
                                "
                                [label]="notBookmarkedAttribute.label"
                                [labelTooltip]="notBookmarkedAttribute.labelTooltip"
                                [tooltip]="
                                    editEntityDetailService.businessIdentifierKey() === notBookmarkedAttribute.key
                                        ? ('modifyBusinessIdentifier' | transloco)
                                        : (nonEditableColumnsReasonByName()[notBookmarkedAttribute.key] ?? undefined)
                                " />
                        } @else {
                            <div class="py-1">
                                <div
                                    class="text-sm text-custom-text-grey"
                                    [matTooltip]="notBookmarkedAttribute.labelTooltip"
                                    [matTooltipDisabled]="!notBookmarkedAttribute.labelTooltip">
                                    {{ notBookmarkedAttribute.label }}
                                </div>
                                <div class="text-sm font-medium">{{ notBookmarkedAttribute.formattedValue }}</div>
                            </div>
                        }
                    }
                }
            </div>
        }

        @if (notBookmarkedAttributes() && notBookmarkedAttributes()!.length) {
            <app-button
                iconSize="xs"
                [icon]="['fas', showAll() ? 'chevron-up' : 'chevron-down']"
                [iconPosition]="IconPosition.END"
                [label]="buttonLabel()"
                [type]="ButtonType.UNDERLINE"
                (onClick)="toggleList()" />
        }
    </div>
</app-expansion-panel>
